const ARTEMIS_PALETTE = ['#00c896', '#4fc3f7', '#f06292', '#ffb74d', '#b39ddb', '#ef5350', '#26a69a']

const DARK_TOKENS = {
  isDark: true,
  text: '#e8edf5',
  muted: '#7a8fa6',
  border: '#243246',
  grid: '#243246',
}

const LIGHT_TOKENS = {
  isDark: false,
  text: '#0f172a',
  muted: '#64748b',
  border: '#e2e8f0',
  grid: '#e2e8f0',
}

export function getArtemisPalette() {
  return ARTEMIS_PALETTE
}

export function getArtemisChartTokens() {
  if (typeof document === 'undefined') {
    return DARK_TOKENS
  }

  const isDark =
    document.body.classList.contains('admin-app-ui') ||
    document.documentElement.classList.contains('dark')

  return isDark ? DARK_TOKENS : LIGHT_TOKENS
}

export function createArtemisBaseOptions({ type, height = 350, colors = ARTEMIS_PALETTE } = {}) {
  const tokens = getArtemisChartTokens()

  return {
    chart: {
      type,
      height,
      background: 'transparent',
      foreColor: tokens.muted,
      toolbar: {
        show: true,
        tools: {
          download: true,
          selection: false,
          zoom: false,
          zoomin: false,
          zoomout: false,
          pan: false,
          reset: false,
        },
      },
      animations: {
        enabled: true,
        easing: 'easeinout',
        speed: 450,
      },
    },
    colors,
    dataLabels: {
      enabled: false,
    },
    stroke: {
      lineCap: 'round',
    },
    grid: {
      borderColor: tokens.grid,
      strokeDashArray: 4,
    },
    legend: {
      labels: {
        colors: tokens.muted,
      },
      fontSize: '12px',
      fontFamily: 'DM Sans, Inter, system-ui, sans-serif',
    },
    tooltip: {
      theme: tokens.isDark ? 'dark' : 'light',
      style: {
        fontSize: '12px',
        fontFamily: 'DM Sans, Inter, system-ui, sans-serif',
      },
    },
    theme: {
      mode: tokens.isDark ? 'dark' : 'light',
    },
  }
}

export function createArtemisAxisOptions() {
  const tokens = getArtemisChartTokens()
  return {
    labels: {
      style: {
        colors: tokens.muted,
        fontFamily: 'DM Sans, Inter, system-ui, sans-serif',
        fontSize: '11px',
      },
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  }
}
